export const IS_RESUME_UPLOADED = "IS_RESUME_UPLOADED";

export const isResumeUploaded = (status) => {
    return {
        type: IS_RESUME_UPLOADED,
        status
    }
};